import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';



export default function ContactUs() {
  return (
    <div style={{background: "linear-gradient(135deg, #f8fafc 60%, #e0e7ef 100%)", minHeight: "100vh"}}>
      <div className="container py-5">
        <div className="row justify-content-center mb-4">
          <div className="col-12 text-center">
            <h2 className="fw-bold mb-2" style={{color: "#1a2740", fontWeight: 700, letterSpacing: 1}}>Contact Us</h2>
            <p className="lead" style={{color: "#374151"}}>Reach out to the Madurai School Education Commission and our main offices for any queries or information.</p>
          </div>
        </div>
        <Row className="g-4 justify-content-center">
          <Col xs={12} md={6} lg={4} className='d-flex align-items-stretch'>
            <Card className="shadow-lg border-0 w-100" style={{borderRadius: 18, overflow: "hidden", background: "#fff", minHeight: "260px"}}>
              <Card.Body className="d-flex flex-column justify-content-center text-center" style={{padding: "2rem"}}>
                <Card.Title className="mb-3" style={{fontWeight: 700, color: "#1a2740", fontSize: "1.15rem"}}>Madurai School Education Commission</Card.Title>
                <Card.Text style={{fontSize: "1.05rem", color: "#374151", lineHeight: "2"}}>
                  Jesuit Madurai Province <br />
                  Maduralaya, Beschi Illam <br />
                  Post. Box.90, Karur Road, <br />
                  Dindigul – 624 001
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6} lg={4} className='d-flex align-items-stretch'>
            <Card className="shadow-lg border-0 w-100" style={{borderRadius: 18, overflow: "hidden", background: "#fff", minHeight: "260px"}}>
              <Card.Body className="d-flex flex-column justify-content-center text-center" style={{padding: "2rem"}}>
                <Card.Title className="mb-3" style={{fontWeight: 700, color: "#1a2740", fontSize: "1.15rem"}}>Main Office</Card.Title>
                <Card.Text style={{fontSize: "1.05rem", color: "#374151", lineHeight: "2"}}>
                  St. Mary’s Higher Secondary School <br />
                  Madurai,<br />
                  Tamilnadu – 625 001
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={6} lg={4} className='d-flex align-items-stretch'>
            <Card className="shadow-lg border-0 w-100" style={{borderRadius: 18, overflow: "hidden", background: "#fff", minHeight: "260px"}}>
              <Card.Body className="d-flex flex-column justify-content-center text-center" style={{padding: "2rem"}}>
                <Card.Title className="mb-3" style={{fontWeight: 700, color: "#1a2740", fontSize: "1.15rem"}}>Our Colleges</Card.Title>
                <Card.Text style={{fontSize: "1.05rem", color: "#374151", lineHeight: "2"}}>
                  St. Joseph’s College (Autonomous) <br/>
                  St. Xavier’s College (Autonomous) <br/>
                  St. Xavier’s College of Education (Autonomous)  <br/>                                       
                  Arul Anandar College (Autonomous) <br/>
                  Xavier Institute of Business Management
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
      <style>{`
        .card {
          min-height: 260px;
        }
        @media (max-width: 767.98px) {
          .card {
            min-height: 220px;
          }
        }
      `}</style>
    </div>
  )
}
